import * as R from 'ramda';

import { TaskLocation } from '@atom/types/taskLocation';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import LocationsRow from './LocationsRow';
import { getFilledLocations } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  isCompletedOrAbove: boolean;
  reportLocations: TaskLocation[];
}

const ReportLocationsSection = ({
  isCompletedOrAbove,
  reportLocations,
}: Props) => {
  const filteredLocations = getFilledLocations(
    reportLocations,
    isCompletedOrAbove,
  );

  const showLocations = !isNilOrEmpty(filteredLocations);

  const rows = R.splitEvery(2, filteredLocations.locations);

  return showLocations ? (
    <>
      <div className={classes.unifiedDataRow}>
        <div
          className={classes.dataCell}
        >{`Management Unit: ${filteredLocations.managementUnit}`}</div>
        <div
          className={classes.dataCell}
        >{`County: ${filteredLocations.county}`}</div>
        <div
          className={classes.dataCell}
        >{`Road Class: ${filteredLocations.roadClass}`}</div>
      </div>
      <div className={classes.locationTableHeaderContainer}>
        <div className={classes.locationTableHeader}>
          <div className={classes.locationHeaderRoute}>Route</div>
          <div className={classes.locationTableSub}>
            <div className={classes.locationHeaderCell}>Direction</div>
            <div className={classes.locationHeaderCell}>Start MP</div>
            <div className={classes.locationHeaderCell}>End MP</div>
          </div>
        </div>
        <div className={classes.locationTableHeader}>
          <div className={classes.locationHeaderRoute}>Route</div>
          <div className={classes.locationTableSub}>
            <div className={classes.locationHeaderCell}>Direction</div>
            <div className={classes.locationHeaderCell}>Start MP</div>
            <div className={classes.locationHeaderCell}>End MP</div>
          </div>
        </div>
      </div>
      <div>
        {rows.map((rowLocations, index) => (
          <LocationsRow key={index} rowLocations={rowLocations} />
        ))}
      </div>
    </>
  ) : (
    <div />
  );
};

export default ReportLocationsSection;
